
import styles from './mainSection.module.css';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { faqApi } from '../../api/faqQuery/faqApi.js';
import { MarkupLayout } from '../ui/markupLayout/MarkupLayout.jsx';
import { Filter } from '../ui/filter/Filter.jsx';
import { filterButtons } from '../../constants/faqPage/filterButtons.js';
import { Details } from '../ui/details/Details.jsx';
import { useNavigate } from 'react-router';

export function MainSection() {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState('filter');

  const { data: faqData, isLoading, isError } = useQuery({ ...faqApi.getFaqList(activeButton) });


  if (isError) {
    navigate('/error');
  }
  const filters = filterButtons(activeButton);

  return (
    <section>
      <MarkupLayout>
        <h1 className={styles.header}>
          часто задаваемые
          <br />
          вопросы
        </h1>
        <div className={styles.filtersContainer}>
          {filters?.map((item, id) => (
            <Filter key={id} item={item} setActiveButton={setActiveButton} />
          ))}
        </div>
        <div className={styles.wrapper}>
          {faqData?.data?.map((item, id) => {
            return (
              <Details
                answer={item.answer}
                question={item.question}
                sub_question={item.subquestion}
                key={`item.question${id}`}
              />
            );
          })}
        </div>
      </MarkupLayout>
    </section>
  );
}
